import React, { useState, useEffect } from 'react';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as departmentActions from '../../Redux/Actions/department';
import * as masterProcessActions from '../../Redux/Actions/masterProcess';
import * as processActions from '../../Redux/Actions/process';
import * as processCosts from '../../Redux/Actions/processCost';
import { toastMessage } from '../../utils/toast';
import { getParams } from '../../utils';
import { useDispatch } from 'react-redux';
import { clearSession } from '../../utils/initiate';

const MasterInfo = ({match, history}) => {
    const [data, setData] = useState([]);
    const [processCostValue, setProcessCostValue] = useState('');
    const [dropDownValue, setDropDownValue] = useState('');
    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();
    const { t } = useTranslation();

    let params = getParams(window.location.search);
    let masterID = params.masterID;
    let {type: masterType} = match.params;
    let typeName = masterType.includes('department') ? 'Department' : (masterType.includes('master') ? 'Master Process' : 'Process');
    let dropDownType = (masterType.includes('master') ? 'department' : masterType.includes('process') ? 'master-process' : '');
    let dropDownID = (masterType.includes('master') ? 'department' : masterType.includes('process') ? 'masterProcess' : '');

    useEffect(() => {
        setLoading(true);
        let type = masterType.includes('department') ? departmentActions : (masterType.includes('master') ? masterProcessActions : masterType.includes('process') ? processActions : '');
        (type !== '') && type.getIndividual(masterID).then(res => {
            if(res && res.data){
                let data = res.data;
                setData(res.data);

                let dropDownApiType = (masterType.includes('master') ? departmentActions : masterType.includes('process') ? masterProcessActions : '');
                (dropDownApiType !== '') && dropDownApiType.getAll().then(dropDownApiData => {
                    if(dropDownApiData && dropDownApiData.data){
                        let dropDownData = dropDownApiData.data.filter(({id}) => id === data[dropDownID].id)[0];
                        setDropDownValue(dropDownData);
                    }else{
                        toastMessage('error', (dropDownApiData && dropDownApiData.message) || `Unable to load the ${typeName}`);
                    }
                });

                (typeName === 'Process') && masterType.includes('process') && processCosts.getAll().then(res => {
                    if(res && res.data){
                        let existingProcessCostData = res.data.filter(({id}) => id === data.processCostId)[0];
                        setProcessCostValue((existingProcessCostData && existingProcessCostData.length !== 0) ? existingProcessCostData && existingProcessCostData.name : `Select Process Cost`);
                    }else{
                        toastMessage('error', 'Unable to get the process costs');
                    }
                });
            }else{
                toastMessage('error', (res && res.message) || `Unable to get the ${typeName} info`);
            }
            setLoading(false);
        }).catch(err => {
            (err.response.status === 401) && clearSession(dispatch, history);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [masterID]);
    
    return(
        <>
           <div className="container-fluid">
                <div className="my-4">
                    <span className="card-label font-weight-bolder c-pointer" onClick={() => history.push(`/master/manage/${masterType}`)}>{t(`mastersManagement.${masterType}.manage`)}</span>
                    <span className="card-label font-weight-bolder mx-2">/</span>
                    <span className="card-label font-weight-bolder text-dark">{data.name}</span>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-stretch">
                            <div className="card-header border-0 py-2">
                                <h3 className="card-title align-items-start flex-column">
                                    <span className="card-label font-weight-bolder text-dark">{t(`mastersManagement.${masterType}.infoTitle`)}</span>
                                </h3>
                            </div>
                            {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center'}} />
                            : <div className="card-body pt-0 pb-3">
                                <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.name")}</label>
                                    <input name="email" value={data.name} readOnly type="text" className="form-control" />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.arabicName")}</label>
                                    <input name="email" value={data.arabicName} readOnly type="text" className="form-control" />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.description")}</label>
                                    <input name="email" value={data.description} readOnly type="text" className="form-control" />
                                </div>
                                <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.arabicDescription")}</label>
                                    <input name="email" value={data.arabicDescription} readOnly type="text" className="form-control" />
                                </div>
                                {masterType.includes('department') && <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.icon")}</label>
                                    <div>
                                        <img src={(data.icon === null) ? '/Assets/nopreview.png' : data.icon} style={{width: '60px', height: 'auto'}} alt='Department Icon' />
                                    </div>
                                </div>}
                                {(masterType !== 'department') && <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t(`mastersManagement.${dropDownType}.dropDown`)}</label>
                                    <input name="email" value={dropDownValue && dropDownValue.name} readOnly type="text" className="form-control" />
                                </div>}
                                {(masterType === 'process') && <div className="form-group fv-plugins-icon-container">
                                    <label className="mb-1">{t("mastersManagement.add.processCost")}</label>
                                    <input name="email" value={processCostValue} readOnly type="text" className="form-control" />
                                </div>}
                            </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MasterInfo;